import React, { useContext } from "react";
import ReportDataGrid, { GridDataContext } from "./ReportDataGrid";

const titleWidth = 300,
    dateWidth = 120;

export default function EpisodeDataGrid({ gridData, onGridRender, columnCount, rowCount }) {
    return (
        <ReportDataGrid
            gridData={gridData}
            columnCount={columnCount}
            rowCount={rowCount}
            columnWidth={120}
            rowHeight={40}
            itemsRenderedCallback={onGridRender}
            corner={EpisodeCornerHeader}
            rowHeader={EpisodeRowHeader}
        />
    );
}

const EpisodeCornerHeader = React.memo(({ columnWidth, rowHeight }) => {
    const { getGrandTotal, getShowTitle } = useContext(GridDataContext);
    const title = getShowTitle();
    return (
        <div style={{ width: titleWidth + dateWidth + columnWidth, height: rowHeight * 2 }}>
            <div
                className="h1 left"
                style={{
                    position: "absolute",
                    height: rowHeight,
                    width: titleWidth,
                    top: 0,
                    left: 0
                }}
            >
                Title
            </div>
            <div
                className="h1"
                style={{
                    position: "absolute",
                    height: rowHeight,
                    width: dateWidth,
                    top: 0,
                    left: titleWidth
                }}
            >
                Published
            </div>
            <div
                className="h1 last"
                style={{
                    position: "absolute",
                    height: rowHeight,
                    width: columnWidth,
                    top: 0,
                    left: titleWidth + dateWidth
                }}
            >
                Total
            </div>

            <div
                className="h2 left bold"
                style={{
                    position: "absolute",
                    height: rowHeight,
                    width: titleWidth + dateWidth,
                    top: rowHeight,
                    left: 0,
                    textAlign: "left"
                }}
                title={title}
            >
                {title}
            </div>
            <div
                className="h2 last bold"
                style={{
                    position: "absolute",
                    height: rowHeight,
                    width: columnWidth,
                    top: rowHeight,
                    left: titleWidth + dateWidth
                }}
            >
                {getGrandTotal()}
            </div>
        </div>
    );
});

const EpisodeRowHeader = React.memo(({ rowStart, rowStop, columnWidth, rowHeight }) => {
    const { getRowTitle, getRowDate, getRowTotal } = useContext(GridDataContext);

    return (
        <>
            {Array.from({ length: rowStop - rowStart + 1 }, (_, i) => {
                const index = rowStart + i;
                //const value = periodHeader(index);
                const value = index;
                const title = getRowTitle(index);
                return (
                    <React.Fragment key={index}>
                        <div
                            className="h2 left"
                            style={{
                                position: "absolute",
                                height: rowHeight,
                                width: titleWidth,
                                top: rowHeight * index,
                                left: 0
                            }}
                            title={title}
                        >
                            {title}
                        </div>
                        <div
                            className="h2"
                            style={{
                                position: "absolute",
                                height: rowHeight,
                                width: dateWidth,
                                top: rowHeight * index,
                                left: titleWidth
                            }}
                        >
                            {getRowDate(index)}
                        </div>
                        <div
                            className="h2 last bold"
                            style={{
                                position: "absolute",
                                height: rowHeight,
                                width: columnWidth,
                                top: rowHeight * index,
                                left: titleWidth + dateWidth
                            }}
                        >
                            {getRowTotal(index)}
                        </div>
                    </React.Fragment>
                );
            })}
        </>
    );
});
